import PropTypes from 'prop-types'
import {
  Table, Button, Tag, Popconfirm,
} from 'antd'
import {
  EditTwoTone, DeleteTwoTone, PlusOutlined, ZoomInOutlined,
} from '@ant-design/icons'
import history from 'utils/history'
import Browser from '../../../utils/Browser'
const NewsList = ({
  data, isLoading, handleDelete,
  handleChangePage,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: '',
      key: 'No',
      width: 80,
      render: (text, record, index) => (data.meta.limit * (data.meta.page - 1)) + index + 1,
    },
    {
      title: 'Judul',
      dataIndex: 'title',
      key: 'title',
      render: text => text || '',
    },
    {
      title: 'Deskripsi Singkat',
      dataIndex: 'excerpt',
      key: 'excerpt',
      render: text => text || '-',
    },
    {
      title: 'Pembuat',
      dataIndex: ['creator', 'name'],
      key: 'creator',
      render: text => text || '-',
    },
    {
      title: 'Editor',
      dataIndex: ['editor', 'name'],
      key: 'editor',
      render: text => text || '-',
    },
    {
      title: 'Kategori',
      dataIndex: ['category', 'name'],
      key: 'category',
      render: text => text || '-',
    },
    {
      title: 'Tanggal Mulai Tayang',
      dataIndex: 'published_at',
      key: 'published_at',
      render: text => text || '-',
    },
    {
      title: 'Tanggal Akhir Tayang',
      dataIndex: 'expired_at',
      key: 'expired_at',
      render: text => text || '-',
    },
    {
      title: 'Tempatkan Paling Atas',
      dataIndex: 'is_top',
      key: 'is_top',
      render: text => <Tag color={text ? 'green' : 'red'}>{text ? 'true' : 'false'}</Tag>,
    },
    {
      title: 'Tampilkan pada Slideshow',
      dataIndex: 'slideshow',
      key: 'slideshow',
      render: text => <Tag color={text == 1 ? 'green' : 'red'}>{text == 1 ? 'Ya' : 'Tidak'}</Tag>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: text => <Tag color={text === 'active' ? 'green' : 'red'}>{text}</Tag>,
    },
    {
      title: 'Aksi',
      dataIndex: '',
      key: 'action',
      width: 80,
      render: (text, record) => (
        <div className="d-flex justify-content-center">
          <ZoomInOutlined onClick={()=> Browser.setWindowHref(`/news/${record.id}/detail`)} className="mr-2" />
          <EditTwoTone twoToneColor="#faad14" onClick={()=> Browser.setWindowHref(`/news/${record.id}/edit`)} className="mr-2" />
          <Popconfirm
            title="Apa Anda yakin ingin menghapus Info/Berita?"
            okText="Ya"
            cancelText="Tidak"
            placement="topLeft"
            onConfirm={() => handleDelete(record.id)}
          >
            <DeleteTwoTone twoToneColor="#ff4d4f" />
          </Popconfirm>
        </div>
      ),
    },
  ]

  return (
    <div>
      <div className="pb-3">
        <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
          <h3 className="title-content mb-0">Daftar Info & Berita</h3>
          <Button type="primary" icon={<PlusOutlined />} href="/news/add">
            Tambah Info/Berita
          </Button>
        </div>
      </div>
      <Table
        rowKey="id"
        className="table-striped-rows"
        columns={columns}
        dataSource={data.list}
        loading={isLoading}
        pagination={{
          total: data?.meta?.total,
          pageSize: data?.meta?.limit || 10,
          onChange: handleChangePage
        }}
      />
    </div>
  )
}

NewsList.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  handleDelete: PropTypes.func,
  handleChangePage: PropTypes.func,
}

export default NewsList
